import ApiEndPoints from "../Enums/ApiEndPoint.enum";

import axios from "./Configuration/apiConfiguration";

const addChat = (data: any) =>
    new Promise((resolve, reject) => {
        axios
            .post(ApiEndPoints.chat, data)
            .then((res) => {
                resolve({ status: true, data: res.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });
const getChatByUserId = () =>
    new Promise((resolve, reject) => {
        axios
            .get(`${ApiEndPoints.chat}`, {})
            .then((res) => {
                resolve({ status: true, data: res.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });

const getChatByRoomId = (params: any) =>
    new Promise((resolve, reject) => {
        axios
            .get(`${ApiEndPoints.chat}/${params?.RoomId}/${params?.Inventory_ID}`, {})
            .then((res) => {
                resolve({ status: true, data: res.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });

const getChatByDealershipId = (params: any) =>
    new Promise((resolve, reject) => {
        axios
            .get(`${ApiEndPoints.chat}/delership/${params?.DealerShip}/${params?.Inventory_ID}`, {})
            .then((res) => {
                resolve({ status: true, data: res.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });

const updateNotification = (data: any) =>
    new Promise((resolve, reject) => {
        axios
            .put(`${ApiEndPoints.chat}/notification`, data)
            .then((res) => {
                resolve({ status: true, data: res.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });
const getChatRecievr = (data: any) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${ApiEndPoints.chat}/reciver`, data)
            .then((res) => {
                resolve({ status: true, data: res.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });
export default { addChat, getChatByUserId, getChatByRoomId, updateNotification, getChatRecievr, getChatByDealershipId };
